import { render } from "./Dashboard.vue?vue&type=template&id=0c3ff8a3&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=0c3ff8a3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3ff8a3"],['__file',"src/views/h5/crm/person/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c3ff8a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c3ff8a3', __exports__)) {
    api.reload('0c3ff8a3', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=0c3ff8a3&scoped=true", () => {
    api.rerender('0c3ff8a3', render)
  })

}


export default __exports__